export default __webpack_public_path__ + "static/media/background.8a487b57.png";